import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { MainComponent } from './main/main.component';
import { SelectivePreloadingStrategy } from './selective-preloading.strategy';

export const AppRoutes: Routes = [
  // Comment This For Sobeh
  {
    path: '',
    redirectTo: 'session',
    pathMatch: 'full',
  },
  // UnComment This For Sobeh
  // {
  //   path: '',
  //   redirectTo: 'not-found',
  //   pathMatch: 'full',
  // },
  // {
  //   path: 'register', loadChildren: () =>
  //     import('./calendar/calendar.module').then(m => m.CalendarDemoModule),
  //   data: { preload: true } // Marking register module for preloading
  // },
  // UnComment This For NCA
  // {
  //   path: 'patienthistorysheet', loadChildren: () =>
  //     import('./patienthistorysheet/patienthistorysheet.module').then(m => m.PatienthistorysheetDemoModule),
  //   data: { preload: true } // Marking register module for preloading
  // },
  // UnComment This For NCA
  // {
  //   path: 'patient-feedback-form', loadChildren: () =>
  //     import('./patient-feedback-form/patient-feedback-form.module').then(m => m.PatientFeedbackFormModule),
  //   data: { preload: true } // Marking register module for preloading
  // },
  // Don't Comment This
  {
    path: 'session', loadChildren: () =>
      import('./session/session.module').then(m => m.SessionDemoModule)
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    children: [{
      path: 'dashboard', loadChildren: () =>
        import('./dashboard/dashboard.module').then(m => m.DashboardModule)
    }, {
      path: 'dash-widget', loadChildren: () =>
        import('./dashboard-widgets/dashboard-widgets.module').then(m => m.DashboardWidgetsModule)
    }, {
      path: 'inbox', loadChildren: () =>
        import('./inbox/inbox.module').then(m => m.InboxModule)
    }, {
      path: 'taskboard', loadChildren: () =>
        import('./taskboard/taskboard.module').then(m => m.TaskboardModule)
    }, {
      path: 'chat', loadChildren: () =>
        import('./chat/chat.module').then(m => m.ChatModule)
    }, {
      path: 'calendar', loadChildren: () =>
        import('./calendar/calendar.module').then(m => m.CalendarDemoModule)
    }, {
      path: 'ui-elements', loadChildren: () =>
        import('./ui-elements/ui-elements.module').then(m => m.UiElementsModule)
    }, {
      path: 'components', loadChildren: () =>
        import('./components/components.module').then(m => m.ComponentDemoModule)
    }, {
      path: 'icons', loadChildren: () =>
        import('./icons/icons.module').then(m => m.IconsModule)
    }, {
      path: 'forms', loadChildren: () =>
        import('./forms/forms.module').then(m => m.FormsDemoModule)
    }, {
      path: 'tables', loadChildren: () =>
        import('./tables/tables.module').then(m => m.TablesDemoModule)
    }, {
      path: 'editor', loadChildren: () =>
        import('./editor/editor.module').then(m => m.EditorModule)
    }, {
      path: 'chart', loadChildren: () =>
        import('./chart/charts.module').then(m => m.ChartDemoModule)
    }, {
      path: 'dragndrop', loadChildren: () =>
        import('./drag-and-drop/dragndrop.module').then(m => m.DragDropDemoModule)
    }, {
      path: 'resizable', loadChildren: () =>
        import('./resizable/resizable.module').then(m => m.ResizableDemoModule)
    }, {
      path: 'ngx-toaster', loadChildren: () =>
        import('./ngx-toaster/toaster.module').then(m => m.ToasterDemoModule)
    }, {
      path: 'animation', loadChildren: () =>
        import('./animation/animation.module').then(m => m.AnimationDemoModule)
    }, {
      path: 'maps', loadChildren: () =>
        import('./maps/maps.module').then(m => m.MapsDemoModule)
    }, {
      path: 'user-pages', loadChildren: () =>
        import('./user-pages/users.module').then(m => m.UsersDemoModule)
    }, {
      path: 'pages', loadChildren: () =>
        import('./custom-pages/pages.module').then(m => m.PagesDemoModule)
    }, {
      path: 'blog', loadChildren: () =>
        import('./blog/blogs.module').then(m => m.BlogsDemoModule)
    }, {
      path: 'gallery', loadChildren: () =>
        import('./gallery/gallery.module').then(m => m.GalleryDemoModule)
    }, {
      path: 'ecommerce', loadChildren: () =>
        import('./ecommerce/ecommerce.module').then(m => m.EcommerceDemoModule)
    }, {
      path: 'user-management', loadChildren: () =>
        import('./user-manage/user-manage.module').then(m => m.UserManageModule)
    }, {
      path: 'master', loadChildren: () =>
        import('./master/master.module').then(m => m.MasterModule)
    }, {
      path: 'transaction', loadChildren: () =>
        import('./transaction/transaction.module').then(m => m.TransactionModule)
    }, {
      path: 'opd', loadChildren: () =>
        import('./opd/opd.module').then(m => m.OpdModule)
    }, {
      path: 'ipd', loadChildren: () =>
        import('./ipd/ipd.module').then(m => m.IpdModule)
    }, {
      path: 'patient-search', loadChildren: () =>
        import('./patient-search/patient-search.module').then(m => m.PatientSearchModule)
    }, {
      path: 'reports', loadChildren: () =>
        import('./report/report.module').then(m => m.ReportModule)
    }, {
      path: 'tools', loadChildren: () =>
        import('./tools/tools.module').then(m => m.ToolsModule)
    },
    {
      path: 'accounts', loadChildren: () =>
        import('./accounts/accounts.module').then(m => m.AccountsModule)
    },
    {
      path: 'pathology', loadChildren: () =>
        import('./pathology/pathology.module').then(m => m.PathologyModule)
    },
    {
      path: 'pharmacy', loadChildren: () =>
        import('./pharmacy/pharmacy.module').then(m => m.PharmacyModule)
    },
    {
      path: 'operation-theatre', loadChildren: () =>
        import('./operation-theatre/operation-theatre.module').then(m => m.OperationTheatreModule)
    },
    {
      path: 'shedule-master', loadChildren: () =>
        import('./shedule-master/shedule-master.module').then(m => m.ScheduleMasterModule)
    },
    {
      path: 'facility-management', loadChildren: () =>
        import('./facility-management/facility-management.module').then(m => m.FacilityManagementModule)
    },
    {
      path: 'video-conference', loadChildren: () =>
        import('./video-conference/video-conference.module').then(m => m.VideoConferenceModule)
    },
    {
      path: 'diagnostic-external-patient', loadChildren: () =>
        import('./diagnostic-external-patient/diagnostic-external-patient.module').then(m => m.DiagnosticExternalPatientModule)
    },
    {
      path: 'analytics-dashboard', loadChildren: () =>
        import('./analytics-dashboard/analytics-dashboard.module').then(m => m.AnalyticsDashboardModule)
    },
    {
      path: 'payment-gateway-auth', loadChildren: () =>
        import('./payment-gateway/payment-gateway.module').then(m => m.PaymentGatewayModule)
    },
    {
      path: 'booking-eligible', loadChildren: () =>
        import('./booking-eligible/booking-eligible.module').then(m => m.BookingEligibleModule)
    },
    {
      path: 'finance-management', loadChildren: () =>
        import('./finance-management/finance-management.module').then(m => m.FinanceManagementModule)
    },
    {
      path: 'treatment-dashboard', loadChildren: () =>
        import('./treatment-dashboard/treatment-dashboard.module').then(m => m.TreatmentDashboardModule)
    },
    {
      path: 'diet-dashboard', loadChildren: () =>
        import('./diet-dashboard/diet-dashboard.module').then(m => m.DietDashboardModule)
    },
    {
      path: 'messaging-portal', loadChildren: () =>
        import('./messaging-portal/messaging-portal.module').then(m => m.MessagingPortalModule)
    },
    {
      path: 'abdm', loadChildren: () =>
        import('./abdm/Abdm.module').then(m => m.AbdmModule)
    },
    ],
  },
  // Comment This For Sobeh
  {
    path: '**',
    redirectTo: 'session'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes, {
    useHash: true, relativeLinkResolution: 'legacy',
    preloadingStrategy: SelectivePreloadingStrategy
  })],
  exports: [RouterModule],
  providers: [SelectivePreloadingStrategy]
})
export class RoutingModule { }

